import React from 'react'
import Layout from '../../../../../brands/components/Layout'
import { Formik } from 'formik'
import { InputField } from '../../../../../../components'
import SelectField from '../../../../../../components/Form/Select'
import TextAreaField from '../../../../../../components/Form/TextArea'
import { convertDateFormat } from '../../../../../holidays/utils'
import './index.css'
import { MAX_CHAR_COUNT } from '../../../../../../utils/index'

const AddTime: React.FC = () => {
    return (
        <div>
            <Layout>
                <div className="">
                    <div className="mb-3">
                        <h4>Add Time Off For Missing Work</h4>
                    </div>
                    <div className="upload-form">
                        <Formik
                            initialValues={{
                                email: '',
                                password: '123Pa$$word!',
                                date: convertDateFormat('12/3/24'),
                            }}
                            onSubmit={() => console.log('')}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="row mrg-top">
                                        <div className="col-sm-3">
                                            <InputField
                                                type="date"
                                                name="holidayDate"
                                                placeholder={convertDateFormat(
                                                    '12/3/24'
                                                )}
                                                lable="Date"
                                                value={values.date}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.date}
                                                touched={touched.date}
                                                classtype={true}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-3">
                                            <SelectField
                                                name="exampleSelect"
                                                label="Time Off Type"
                                                options={[
                                                    {
                                                        value: '',
                                                        label: 'Select',
                                                    },
                                                    {
                                                        value: 'Australia',
                                                        label: 'Australia',
                                                    },
                                                ]}
                                                value={values.password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                                defaultValue="option1"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <TextAreaField
                                                name="exampleTextArea"
                                                label="Reasons/Notes"
                                                placeholder=""
                                                value={''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.password}
                                                touched={touched.password}
                                                defaultValue=""
                                                rows={6}
                                                maxLength={MAX_CHAR_COUNT}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-4 mb-4">
                                        <div className="col-sm-6 button-block">
                                            <a className="button button-primary me-5">
                                                SUBMIT
                                            </a>
                                            <a className="button button-outline">
                                                CANCEL
                                            </a>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default AddTime
